{
  "footer": {
    "text": {
      "imprint": "Impressum",
      "privacy-policy": "Datenschutz",
      "powered": "Angetrieben von Lumxi GmbH"
    }
  }
}
